import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { EntDescription } from '@bazis/shared/models/srv.types';
import { CommonModule } from '@angular/common';
import { EntityPipe } from '@bazis/shared/pipes/entity.pipe';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'bazis-gallery-single-slider',
    templateUrl: './gallery-single-slider.component.html',
    imports: [CommonModule, EntityPipe, IconModule, ColorDirective, ButtonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GallerySingleSliderComponent {
    readonly images = input<EntDescription[]>();

    //  Если необходимо задать отличный от имени файла alt картинкам
    readonly imagesAlt = input<string[]>();

    readonly iconPrev = input('angle-small-left');

    readonly iconNext = input('angle-small-right');

    readonly fillControl = input<'solid' | 'outline' | 'clear'>('outline');

    readonly sizeControl = input<SizeRange>(SizeRange.regular);

    currentIndex = 0;
}
